exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\na.v-list__tile.v-list__tile--link.v-list__tile--disabled.theme--light {\n    background-color: #EEE;\n}\n.team-list-wrapper {\n    max-height: calc(100vh - 180px);\n    overflow: auto;\n}\n.user-menu-list-wrapper {\n    max-height: calc(100vh - 90px);\n    overflow: auto;\n}\n", ""]);

// exports
